import {
  CalendarClock,
  Coins,
  HeartHandshake,
  House,
  Landmark,
  TrendingUp,
  type LucideIcon,
} from "lucide-react";
import type { Domain } from "./domains";

export type RoleKey =
  | "brukare"
  | "medarbetare"
  | "planerare"
  | "agare"
  | "kommun"
  | "samhalle";

/** The one role → domain → icon table. Pages never choose a role colour. */
export const roles: Record<RoleKey, { domain: Domain; icon: LucideIcon }> = {
  brukare: { domain: "human", icon: House },
  medarbetare: { domain: "care", icon: HeartHandshake },
  planerare: { domain: "planning", icon: CalendarClock },
  agare: { domain: "attention", icon: TrendingUp },
  kommun: { domain: "continuity", icon: Landmark },
  samhalle: { domain: "society", icon: Coins },
};

export const roleKeys = Object.keys(roles) as RoleKey[];
